
import React, { Suspense } from 'react';
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";

interface HeaderActionsProps {
  isMobile: boolean;
  isAuthenticated: boolean;
  onMobileMenuToggle: () => void;
  CartComponent: React.LazyExoticComponent<React.ComponentType<any>>;
}

const CartLoadingSpinner = () => (
  <div className="w-10 h-10 bg-gray-700 rounded-full animate-pulse" />
);

const HeaderActions = ({ isMobile, isAuthenticated, onMobileMenuToggle, CartComponent }: HeaderActionsProps) => {
  if (isMobile) {
    return (
      <>
        <Button variant="ghost" size="icon" onClick={onMobileMenuToggle} aria-label="Open main menu">
          <Menu className="h-6 w-6" />
        </Button>
        <Suspense fallback={<CartLoadingSpinner />}>
          <CartComponent />
        </Suspense>
      </>
    );
  }

  return (
    <>
      <Link to="/order-tracking" className="px-3 py-2 text-sm hover:text-gaming-blue">
        Track Order
      </Link>
      {isAuthenticated ? (
        <Link to="/account" className="px-3 py-2 text-sm hover:text-gaming-blue">
          Account
        </Link>
      ) : (
        <Link to="/auth" className="px-3 py-2 text-sm hover:text-gaming-blue">
          Sign In
        </Link>
      )}
      <Suspense fallback={<CartLoadingSpinner />}>
        <CartComponent />
      </Suspense>
    </>
  );
};

export default HeaderActions;
